import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

// Components
import ModalHeader from '@common-components/headers/ModalHeader';
import Button from '@common-components/button/Button';
import { INPUT_TYPES } from '@common-components/form/constants/fieldTypes';

// Hooks
import useSelfDesignationOtpRole from '../hooks/useSelfDesignationOtpRole';

const SearchResultModal = ( props ) => {
    const {
        actions: {
            hideModal
        },
        modal: {
            modalData: {
                memberName,
                handleAddToBOBClick
            }
        },
        modalHeaderProps
    } = props;

    const handleRestorationClick = () => {
        hideModal();
    };

    const { role } = useSelfDesignationOtpRole();

    return (
        <Fragment>
            <div className="gi-modal__header__head">
                <ModalHeader { ...{ ...modalHeaderProps, hideModal } } />
            </div>
            <div className="gi-modal__body txt-left" id={`${modalHeaderProps.modalId}_body`}>
                <FormattedMessage
                    id={`selfDesignation.${role}.search.becomeAOR.modal.accept.content.1`}
                    values={{
                        name: memberName,
                        strong: function makeTextStrong (message) {
                            return (<strong>{message}</strong>);
                        }
                    }}
                    tagName='p'
                />
                <FormattedMessage
                    id={`selfDesignation.${role}.search.becomeAOR.modal.accept.content.2`}
                    values={{
                        name: memberName,
                        strong: function makeTextStrong (message) {
                            return (<strong>{message}</strong>);
                        }
                    }}
                    tagName='p'
                />
            </div>
            <div className='gi-modal__controls'>
                <Button
                    { ...{
                        id:'cancel-btn',
                        name:'cancelBtn',
                        type: INPUT_TYPES.BUTTON,
                        outerClass: ['margin-b-20', 'margin-r-10', 'display--inline'],
                        classes:['gi-button__secondary'],
                        btnText:'selfDesignation.search.action-btn.cancel',
                        handleClick: handleRestorationClick
                    }}

                />
                <Button
                    { ...{
                        id:'yes-btn',
                        name:'yesBtn',
                        type: INPUT_TYPES.BUTTON,
                        outerClass: ['margin-b-20', 'display--inline'],
                        classes:['gi-button__primary'],
                        btnText:'selfDesignation.search.action-btn.yes',
                        handleClick: handleAddToBOBClick
                    }}

                />
            </div>
        </Fragment>
    );
};

export default SearchResultModal;